import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {SavedReportsFoldersState} from "./savedReportsFolders";
import {FolderComponentObjects} from '../../classes/folder-component-object';
import {Serializers} from '../../interfaces/serializer';
import {SavedReportFolder} from '../../interfaces/saved-report-folder';

export const selectReportsFoldersState = createFeatureSelector('savedReportsFolders');

export const selectReportsFoldersLoading: MemoizedSelector<object, boolean> = createSelector(
  selectReportsFoldersState, (
    reportsFoldersState: SavedReportsFoldersState) => reportsFoldersState.loading
);

export const selectReportsFoldersLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectReportsFoldersState,
  (reportsFoldersState: SavedReportsFoldersState) => reportsFoldersState.loaded
);

export const selectReportsFoldersInitialized: MemoizedSelector<object, boolean> = createSelector(
  selectReportsFoldersState,
  (reportsFoldersState: SavedReportsFoldersState) => reportsFoldersState.initialized
);

export const selectReportsFolders: MemoizedSelector<object, Serializers<SavedReportFolder>> = createSelector(
  selectReportsFoldersState,
  (reportsFoldersState: SavedReportsFoldersState) => reportsFoldersState.serialized
);

export const selectFolderComponentObjects: MemoizedSelector<object, FolderComponentObjects> = createSelector(
  selectReportsFoldersState,
  (reportsFoldersState: SavedReportsFoldersState) => reportsFoldersState.componentObjects
);
